import * as React from 'react';
import * as Dictionary from 'Models/Dictionary';
import {WrappedFieldProps} from 'redux-form';
import {OptionsElement} from './../../../../Models/ViewManagementModel';

type Props = {
    label: string;
    type: string;
    max?: number;
    min?: number;
    disabled: boolean;
    options: Array<OptionsElement>;
};

// export default class CarCategorySelect extends React.Component<CarCategorySelectP, {}> {
class PrioritySelect extends React.PureComponent<WrappedFieldProps & Props> {
    public handleClick(value) {
        if (this.props.disabled) {
            return null;
        } else {
            this.props.input.onChange(value);
        }
    }

    public render() {
        const {input, meta, label, options} = this.props;
        return (
            <div className="form-field form-field--priority">
                <label htmlFor={input.name} className="form-field__label">{label}</label>
                <div className="form-field__group form-field__group--border">
                    {options.map((element, idx) => {
                        const active = element.value === input.value;
                        return (
                            <div key={`${element}-${idx}`}
                                 className={`flex flex--justify-center form-field__priority-image ${active ? 'form-field__priority-image--active' : ''}`}
                                 onClick={() => this.handleClick(element.value)}>
                                <img src={Dictionary.PriorityIcons.get(element.value)} alt="" width={15}/>
                            </div>
                        );
                    })}
                </div>
                {(meta.touched &&
                    (meta.error && (
                        <div className="form_field--error_wrapper">
                            <span className="form_field--error">{meta.error}</span>
                        </div>
                    ))) ||
                (meta.warning && <span>{meta.warning}</span>)}
            </div>
        );
    }
}

export default PrioritySelect;



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/PrioritySelect.tsx